export default {
  common: {
    cancel: "Annuleren",
    add: "Toevoegen",
    back: "Terug", 
    next: "Volgende", 
    submit: "Verzenden",
    saving: "Opslaan…",
    saved: "Opgeslagen ✓",
  },
  
  menu: {
    backToDashboard: "Terug naar dashboard",
    myObjects: "Mijn accommodaties",
    settings: "Instellingen",
    help: "Hulp / Contact",
    logout: "Uitloggen",
    language: "Nederlands",
  },

  contact: {
    title: "Contact",
    subtitle: "Hoe kunnen we je helpen?",
    messageLabel: "Je bericht",
    send: "Bericht verzenden",
    success: "Bericht succesvol verzonden!",
    close: "Sluiten",
  },

  dashboard: {
    welcome: "Welkom terug, ",
    overview: "Mijn overzicht",
    summaryText: "Hier vind je een snel overzicht van de status van je accommodaties.",
    activeObjects: "Accommodatie(s) online",
    inReviewObjects: "Accommodatie(s) in beoordeling",

    contact: "Mijn contactgegevens",
    editContact: "Bewerken",

    settings: "Mijn instellingen",
    subscription: "Abonnement",
    subscriptionActive: "Actief",
    password: "Wachtwoord",
    changePassword: "Wachtwoord wijzigen",

    objects: "Mijn accommodaties",
    objectboxText: "Beschikbaarheid en prijzen invoeren",
    objectboxText2: "Accommodatiegegevens bewerken",
    objectbuttonText: "Accommodaties beheren",

    newObjectContainer: "Nieuwe accommodatie aanmaken",
    newObjectDescription: "Maak een nieuwe accommodatie aan of ga verder met een bestaande conceptversie.",
    continueDraft: "➜ Doorgaan met concept",
    newObject: "+ Nieuwe accommodatie aanmaken",

    documents: "Documenten",
    lastInvoice: "Laatste factuur",
    openArchive: "Archief openen",
  },

  contactEdit: {
    title: "Contactgegevens bewerken",
    errorLoading: "Fout bij het laden van gegevens.",
    errorSaving: "Fout bij het opslaan van gegevens.",
    confirmLeave: "Wil je de wijzigingen opslaan?",
    salutation: "Aanhef",
    selectSalutation: "Selecteer een aanhef",
    company: "Bedrijf",
    firstName: "Voornaam",
    lastName: "Achternaam",
    street: "Straat",
    houseNumber: "Huisnummer",
    postalCode: "Postcode",
    town: "Plaats",
    country: "Land",
    selectCountry: "Selecteer een land",
    phone: "Telefoonnummer",
    cancel: "Annuleren",
    save: "Opslaan",
    requiredFields: "Vul alle verplichte velden in.",
  },

  registerUser: {
    title: "Contactgegevens",
    verifiedMessage:
      "Je e-mailadres is succesvol geverifieerd. Vul nu je contactgegevens in.",

    salutation: "Aanhef",
    selectSalutation: "Selecteer een aanhef",
    company: "Bedrijf (optioneel)",
    firstName: "Voornaam",
    lastName: "Achternaam",
    street: "Straat",
    houseNumber: "Huisnummer",
    postalCode: "Postcode",
    town: "Plaats",
    country: "Land",
    selectCountry: "Selecteer een land",

    phone: "Telefoonnummer",
    phonePlaceholder: "Telefoonnummer",
    phoneCodePlaceholder: "Landcode",
    search: "Zoeken...",
    noResults: "Geen resultaten",

    terms: "Ik accepteer de",
    termsLink: "Algemene voorwaarden",
    privacy: "Ik accepteer de",
    privacyLink: "privacyverklaring",

    save: "Gegevens opslaan",

    requiredFields: "Vul alle verplichte velden in.",
    acceptTerms: "Accepteer de voorwaarden en privacyverklaring.",
    loginFirst: "Log eerst in.",
    errorSaving: "Fout bij het opslaan van gegevens!",
    errorLoading: "Fout bij het laden van gegevens.",
  },

  password: {
    title: "Wachtwoord wijzigen",
    oldPassword: "Huidig wachtwoord",
    newPassword: "Nieuw wachtwoord",
    confirmPassword: "Nieuw wachtwoord bevestigen",

    cancel: "Annuleren",
    save: "Opslaan",

    errorInvalid: "Vul alle velden correct in.",
    errorGeneral: "Fout bij het wijzigen van het wachtwoord.",
    success: "Wachtwoord succesvol gewijzigd.",
    confirmLeave: "Wil je de wijzigingen opslaan?",
  },

  impressum: {
    title: "Juridische informatie",
    company: "glampingoase GmbH",
    addressLine1: "Breechliweg 3",
    addressLine2: "5102 Rupperswil",
    country: "Zwitserland",

    registryNumber: "Handelsregisternummer: CHE-432.303.436",
    registryCourt: "Handelsregister van het kanton Aargau",

    emailLabel: "E-mail",
  },

  footer: {
    impressum: "Juridische informatie",
  },

  objectList: {
    title: "Beschikbaarheid & prijzen beheren",
    loading: "Laden...",
    notConfirmed: "nog niet bevestigd",
    editPrices: "Prijzen bewerken",
    editAvailability: "Beschikbaarheid bewerken",
    noObjectsLine1: "Nog geen accommodatie aangemaakt.",
    noObjectsLine2: "Wil je er nu een aanmaken?",
    createObject: "Nieuwe accommodatie aanmaken",
    imageAlt: "Accommodatieafbeelding",
  },

  prices: {
    openCalendar: "Kalender openen",
    datePlaceholder: "dd.mm.jjjj",
    object: "Accommodatie",

    errorFetchCurrency: "Fout bij het laden van de valuta",
    errorFetchObjects: "Fout bij het laden van accommodaties",
    errorFetchObjectName: "Fout bij het laden van de naam van de accommodatie",
    errorFetchSeasons: "Fout bij het laden van seizoenen",
    errorFetchSeasonsAlert: "Er is een probleem opgetreden bij het laden van de seizoenen.",
    errorNotLoggedIn: "Je bent niet ingelogd.",
    errorMissingFields: "Vul alle velden in.",
    errorEndBeforeStart: "De einddatum mag niet vóór de startdatum liggen.",
    errorOverlap: "Dit seizoen overlapt met een bestaand seizoen.",

    errorSaveSeason: "Fout bij het opslaan van het seizoen",
    errorApiRequest: "Fout bij API-verzoek",
    errorSaveSeasonAlert: "Er is een probleem opgetreden bij het opslaan van het seizoen.",

    confirmDeleteSeason: "Wil je het seizoen verwijderen",
    errorDeleteSeason: "Fout bij het verwijderen van het seizoen",
    errorDeleteSeasonAlert: "Het seizoen kon niet worden verwijderd.",

    errorFinishEditingFirst:
      "Voltooi eerst de huidige bewerking voordat je een nieuw seizoen toevoegt.",

    tabPrices: "Prijzen",
    tabAdditionalCosts: "Extra kosten",
    tabCurrency: "Valuta",
    tabAvailability: "Beschikbaarheid",
    tabObjectList: "Accommodatieoverzicht",

    pricesFor: "Prijzen voor",

    hidePastSeasons: "Verberg afgelopen seizoenen",
    showPastSeasons: "Toon afgelopen seizoenen",

    seasonName: "Seizoensnaam",
    pricePerNight: "Prijs per nacht in",

    saving: "Opslaan...",
    cancel: "Annuleren",
    addSeason: "+ Seizoen toevoegen",

    infoTitle: "Hoe voer ik prijzen in?",

    infoText:
      "Voor elk seizoen stel je een periode in met een begin- en einddatum.\n\n" +
      "Je kunt het seizoen een willekeurige naam geven. Deze is alleen voor je eigen overzicht en wordt niet aan gasten getoond.\n\n" +
      "De prijs geldt per nacht. Zorg ervoor dat seizoenen elkaar niet overlappen. Zo ja, dan verschijnt er een foutmelding.\n\n" +
      "Wanneer alle gegevens correct zijn, bevestig je via het groene vinkje. Het seizoen wordt opgeslagen en je kunt een nieuw seizoen toevoegen.\n\n" +
      "Je kunt slechts één seizoen tegelijk bewerken, omdat elke wijziging automatisch op overlappingen wordt gecontroleerd.\n\n" +
      "Opgeslagen seizoenen kun je bewerken via het potlood-icoon of verwijderen via het prullenbak-icoon. Deze acties zijn alleen mogelijk als er geen andere bewerking actief is.\n\n" +
      "Via de knop 'Toon afgelopen seizoenen' kun je eerdere seizoenen bekijken. Deze zijn alleen ter informatie en kunnen niet meer worden bewerkt.",

    close: "Sluiten",

    selectCurrencyTitle: "Valuta kiezen",
    selectCurrencyText: "Kies een valuta voordat je prijzen toevoegt.",
    currencyRequired: "Selecteer eerst een valuta.",

  },

  additionalCosts: {
    title: "Extra kosten voor",
    object: "Accommodatie",

    add: "Extra kosten toevoegen",

    selectType: "Kies een kostensoort",
    selectUnit: "Kies een eenheid",
    pricePlaceholder: "Prijs in",

    saving: "Opslaan...",
    cancel: "Annuleren",

    finishEditingFirst:
      "Voltooi eerst de huidige bewerking voordat je nieuwe kosten toevoegt.",
    fillAllFields: "Vul alle velden in.",
    confirmDelete: "Wil je deze kosten echt verwijderen?",

    errorLoadingTypes: "Fout bij het laden van kostensoorten",
    errorLoadingUnits: "Fout bij het laden van eenheden",
    errorLoadingCosts: "Fout bij het laden van extra kosten",
    errorSaving: "Fout bij het opslaan",
    errorDeleting: "Fout bij het verwijderen",
  },

  currency: {
    title: "Valuta voor",
    select: "Valuta selecteren",
    saving: "Opslaan...",
    save: "Valuta opslaan",
    saved: "Valuta succesvol opgeslagen",
    errorLoadingCurrencies: "Fout bij het laden van beschikbare valuta",
    errorLoadingObjectCurrency: "Fout bij het laden van de valuta van de accommodatie",
    errorLoadingObjectName: "Fout bij het laden van de naam van de accommodatie",
    errorSaving: "Fout bij het opslaan van de valuta",
    object: "Accommodatie",
  },

availability: {
  settingsTitle: "Instellingen",
  modeTitle: "Beschikbaarheidsmodus",
  modeIcal: "iCal-synchronisatie",
  modeManual: "Handmatige beschikbaarheid",

  warningSwitch: "Bij het wijzigen van de modus worden bestaande beschikbaarheden verwijderd. Doorgaan?",
  saved: "Instellingen opgeslagen.",

  modalTitle: "Hoe wil je je beschikbaarheid beheren?",
  modalText: "Kies een van de twee opties. Je kunt dit later altijd wijzigen.",
  chooseIcal: "iCal-synchronisatie",
  chooseManual: "Handmatige invoer",

  errorLoading: "Fout bij het laden van beschikbaarheden.",
  tabsAriaLabel: "Beschikbaarheids-tabs",

  tabSettings: "Instellingen",
  tabIcal: "iCal beheren",
  tabManual: "Beschikbaarheid invoeren",
  tabPrices: "Prijzen",
  tabObjectList: "Objectoverzicht"
},

availabilityManual: {
  editAvailability: "Beschikbaarheid bewerken",
  loadingObject: "Objectinformatie laden…",

  legendAvailable: "Beschikbaar",
  legendDelete: "Verwijderen",

  savedSuccess: "Beschikbaarheden succesvol opgeslagen!",
  savedPartialError: "Sommige beschikbaarheden konden niet worden opgeslagen of verwijderd.",
  errorSaving: "Fout bij opslaan.",
  errorNoObjectId: "Fout: geen object-ID gevonden."
},

availabilityIcal: {
  title: "iCal-import",
  loading: "Laden…",

  placeholderUrl: "https://voorbeeld.com/kalender.ics",
  testPreview: "Voorbeeld testen",
  testing: "Testen…",
  showSynced: "Gesynchroniseerde gegevens bekijken",

  save: "Opslaan",
  saving: "Opslaan...",
  remove: "Verwijderen",

  lastSync: "Laatste synchronisatie",
  previewFailed: "Voorbeeld mislukt",
  previewCalendar: "Voorbeeld (kalender)",

  prev: "Terug",
  next: "Volgende",

  errorLoading: "Fout bij het laden van iCal-gegevens.",
  errorNoUrl: "Geen iCal-link opgegeven.",
  errorPreview: "Er is een fout opgetreden bij het ophalen van de link.",
  errorInvalidUrl: "Ongeldige URL.",
  errorSaving: "Opslaan mislukt.",
  errorRemove: "Verwijderen mislukt",
  removed: "iCal-link verwijderd",
  saved: "iCal-link opgeslagen. Synchronisatie gestart.",
  errorLoadSynced: "Fout bij het laden van gesynchroniseerde gegevens.",
  errorNoObjectId: "Geen object-ID gevonden."
},


  newObjectModal: {
    title: "Onvoltooide accommodatie gevonden",
    description:
      "Je hebt al een accommodatie in bewerking. Wil je doorgaan of opnieuw beginnen en de bestaande gegevens overschrijven?",
    continue: "Doorgaan met bewerken",
    startNew: "Opnieuw beginnen",
  },

  object: {
    tabs: [
    "Basisgegevens",
    "Kamers",
    "Voorzieningen / Omgeving",
    "Bezetting",
    "Beschrijving",
    "Afbeeldingen",
    "Indienen"
  ],

    step1: {
      title: "Stap 1: Algemene informatie",

      fields: {
        name: "Naam van de accommodatie",
        street: "Straat",
        house_number: "Huisnummer",
        postal_code: "Postcode",
        city: "Plaats",
        object_type: "Type accommodatie",
        country: "Land",
        region: "Regio",
        licence_number: "Licentienummer",
      },

      select: {
        choose: "Selecteer",
      },

      map: {
        info: "De marker wordt automatisch geplaatst op basis van het ingevoerde adres. Indien nodig kun je hem verplaatsen.",
        reset: "Marker terugzetten naar ingevoerd adres",
        load_error: "Kaart kan niet worden geladen.",
        loading: "Kaart wordt geladen...",
      },

      geocode: {
        failed: "Geocodering mislukt.",
        missing_fields:
          "Vul alle adresvelden in en controleer of de Google Maps API is geladen.",
      },
    },
      step2: {
        title: "Stap 2: Kamers & voorzieningen",
        addRoom: "Kamer toevoegen",
        roomCountTitle: "Hoeveel kamers heeft je accommodatie?",
        roomCountDescription: "Voer het aantal per kamertype in. Daarna kun je elke kamer afzonderlijk bewerken.",
        roomCountSharedHint: "Gedeelde ruimtes zoals badkamer en keuken tellen ook mee.",
        addAllRooms: "Alle kamers toevoegen",
        roomType: "Kamertype",
        amount: "Aantal",
        select: "Selecteer",
        usage: "Gebruik",
        private: "Privégebruik",
        shared: "Gedeeld gebruik",
        onlyOneAllowed: "slechts 1 toegestaan",

        // Beds
        beds: "Bedden",
        addBed: "Bed toevoegen",
        bedType: "Bedtype",
        size: "Afmeting",
        sizeWidth: "Breedte (cm)",
        sizeLength: "Lengte (cm)",
        sizeOptional: "Optioneel",
      },
    step3: {
        title: "Stap 3: Voorzieningen & omgeving",
        general: "Algemene voorzieningen",
        outdoor: "Buitenvoorzieningen",
        environmentAmenities: "Voorzieningen in de omgeving",
        environmentCards: "Omgeving",
        errorLoading: "Fout bij het laden van de voorzieningen."
      },
      step4: {
        title: "Stap 4: Bezetting & contactopties",

        maxOccupancy: "Maximale bezetting",
        maxPets: "Maximaal aantal huisdieren",
        minNights: "Minimum verblijf",

        selectPlaceholder: "Selecteer",

        arrivalDays: "Aankomstdagen",

        earliestCheckin: "Vroegste check-in",
        latestCheckout: "Laatste check-out",

        rules: "Regels",
        partyAllowed: "Feesten toegestaan",
        smokingAllowed: "Roken toegestaan",
        yes: "Ja",
        no: "Nee",

        contactOptions: "Contactopties",
        contactHow: "Hoe moeten gasten contact met je opnemen?",
        contactBoth: "Beide",
        contactWebsite: "Website",
        contactWebsitePlaceholder: "https://example.com",
        contactEmail: "E-mail voor contactformulier",

        invalidEmail: "Voer een geldig e-mailadres in.",
        errorLoadingArrivalDays: "Fout bij het laden van aankomstdagen."
      },
      step5: {
        title: "Stap 5: Accommodatiebeschrijving",
        activitiesTitle: "Activiteiten in de buurt",
        activitiesPlaceholder: "Beschrijf wat er in de buurt van je accommodatie te vinden is.",
        descriptionTitle: "Accommodatiebeschrijving",
        descriptionPlaceholder: "Voer een duidelijke tekst in die de accommodatie goed beschrijft."
      },
      step6: {
        title: "Stap 6: Afbeeldingen uploaden",

        titleImage: "Titelafbeelding",
        additionalImages: "Extra afbeeldingen (max. 20)",

        selectOrDragTitle: "Selecteer of sleep je titelafbeelding hierheen",
        dragTitleHere: "Sleep je titelafbeelding hierheen",

        selectOrDragAdditional: "Selecteer bestanden of sleep ze hierheen",
        dragAdditionalHere: "Sleep extra afbeeldingen hierheen",

        uploaded: "Afbeelding geüpload",
        uploadedCount: "{n} afbeelding(en) geüpload",

        errorMinSize: "Afbeelding moet minimaal {w}x{h} pixels zijn.",
        errorInvalidFormat: "Ongeldig afbeeldingsformaat."
      },
      step7: {
        title: "Stap 7: Afronden & abonnement kiezen",
        intro: "Bijna klaar! Kies je abonnement en controleer of alle stappen voltooid zijn.",

        subscriptionTitle: "Abonnement kiezen",

        freeTitle: "Free",
        freePrice: "Gratis",
        freeDescription: "Plaatshoudertekst. Beschrijving komt hier.",

        monthlyTitle: "Maandelijks",
        monthlyPrice: "2 CHF / maand",
        monthlyDescription: "Plaatshoudertekst. Beschrijving komt hier.",

        yearlyTitle: "Jaarlijks",
        yearlyPrice: "20 CHF / jaar",
        yearlyDescription: "Plaatshoudertekst. Beschrijving komt hier.",

        overviewTitle: "Overzicht van je gegevens",
        fix: "Aanvullen",

        overviewItems: [
          { step: 1, title: "Basisgegevens" },
          { step: 2, title: "Kamers" },
          { step: 3, title: "Voorzieningen / Omgeving" },
          { step: 4, title: "Bezetting" },
          { step: 5, title: "Beschrijving" },
          { step: 6, title: "Afbeeldingen" }
        ],

        errorUnknown: "Onbekende fout.",
        errorGeneral: "Er is een fout opgetreden."
      }

  },
};
